export const TENANT_DETAILS_REQUEST = "TENANT_DETAILS_REQUEST";
export const TENANT_DETAILS_SUCCESS = "TENANT_DETAILS_SUCCESS";
export const TENANT_DETAILS_FAIL = "TENANT_DETAILS_FAIL";
export const TENANT_DETAILS_RESET = "TENANT_DETAILS_RESET";

export const TENANT_DETAILS_BY_SLUG_REQUEST = "TENANT_DETAILS_BY_SLUG_REQUEST";
export const TENANT_DETAILS_BY_SLUG_SUCCESS = "TENANT_DETAILS_BY_SLUG_SUCCESS";
export const TENANT_DETAILS_BY_SLUG_FAIL = "TENANT_DETAILS_BY_SLUG_FAIL";
export const TENANT_DETAILS_BY_SLUG_RESET = "TENANT_DETAILS_BY_SLUG_RESET";

export const TENANT_UPDATE_CLINICNAME_REQUEST =
  "TENANT_UPDATE_CLINICNAME_REQUEST";
export const TENANT_UPDATE_CLINICNAME_SUCCESS =
  "TENANT_UPDATE_CLINICNAME_SUCCESS";
export const TENANT_UPDATE_CLINICNAME_FAIL = "TENANT_UPDATE_CLINICNAME_FAIL";
export const TENANT_UPDATE_CLINICNAME_RESET = "TENANT_UPDATE_CLINICNAME_RESET";

export const TENANT_UPDATE_SUPPORTEMAIL_REQUEST =
  "TENANT_UPDATE_SUPPORTEMAIL_REQUEST";
export const TENANT_UPDATE_SUPPORTEMAIL_SUCCESS =
  "TENANT_UPDATE_SUPPORTEMAIL_SUCCESS";
export const TENANT_UPDATE_SUPPORTEMAIL_FAIL =
  "TENANT_UPDATE_SUPPORTEMAIL_FAIL";
export const TENANT_UPDATE_SUPPORTEMAIL_RESET =
  "TENANT_UPDATE_SUPPORTEMAIL_RESET";

export const TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST =
  "TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST";
export const TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS =
  "TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS";
export const TENANT_UPDATE_OPERATINGCOUNTRY_FAIL =
  "TENANT_UPDATE_OPERATINGCOUNTRY_FAIL";
export const TENANT_UPDATE_OPERATINGCOUNTRY_RESET =
  "TENANT_UPDATE_OPERATINGCOUNTRY_RESET";

export const TENANT_UPDATE_ONBOARDING_STATUS_REQUEST =
  "TENANT_UPDATE_ONBOARDING_STATUS_REQUEST";
export const TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS =
  "TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS";
export const TENANT_UPDATE_ONBOARDING_STATUS_FAIL =
  "TENANT_UPDATE_ONBOARDING_STATUS_FAIL";
export const TENANT_UPDATE_ONBOARDING_STATUS_RESET =
  "TENANT_UPDATE_ONBOARDING_STATUS_RESET";

export const TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST =
  "TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST";
export const TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS =
  "TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS";
export const TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL =
  "TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL";
export const TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_RESET =
  "TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_RESET";

export const TENANT_UPDATE_LOGO_REQUEST = "TENANT_UPDATE_LOGO_REQUEST";
export const TENANT_UPDATE_LOGO_SUCCESS = "TENANT_UPDATE_LOGO_SUCCESS";
export const TENANT_UPDATE_LOGO_FAIL = "TENANT_UPDATE_LOGO_FAIL";
export const TENANT_UPDATE_LOGO_RESET = "TENANT_UPDATE_LOGO_RESET";

export const TENANT_UPDATE_CLINIC_DETAILS_REQUEST =
  "TENANT_UPDATE_CLINIC_DETAILS_REQUEST";
export const TENANT_UPDATE_CLINIC_DETAILS_SUCCESS =
  "TENANT_UPDATE_CLINIC_DETAILS_SUCCESS";
export const TENANT_UPDATE_CLINIC_DETAILS_FAIL =
  "TENANT_UPDATE_CLINIC_DETAILS_FAIL";
export const TENANT_UPDATE_CLINIC_DETAILS_RESET =
  "TENANT_UPDATE_CLINIC_DETAILS_RESET";

export const TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST =
  "TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST";
export const TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS =
  "TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS";
export const TENANT_UPDATE_REGIONAL_SETTINGS_FAIL =
  "TENANT_UPDATE_REGIONAL_SETTINGS_FAIL";
export const TENANT_UPDATE_REGIONAL_SETTINGS_RESET =
  "TENANT_UPDATE_REGIONAL_SETTINGS_RESET";

export const TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST =
  "TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST";
export const TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS =
  "TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS";
export const TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL =
  "TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL";
export const TENANT_UPDATE_SCHEDULING_SETTINGS_RESET =
  "TENANT_UPDATE_SCHEDULING_SETTINGS_RESET";

export const TENANT_UPDATE_DENTAL_CHAIRS_REQUEST =
  "TENANT_UPDATE_DENTAL_CHAIRS_REQUEST";
export const TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS =
  "TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS";
export const TENANT_UPDATE_DENTAL_CHAIRS_FAIL =
  "TENANT_UPDATE_DENTAL_CHAIRS_FAIL";
export const TENANT_UPDATE_DENTAL_CHAIRS_RESET =
  "TENANT_UPDATE_DENTAL_CHAIRS_RESET";

export const TENANT_UPDATE_COMPANY_DETAILS_REQUEST =
  "TENANT_UPDATE_COMPANY_DETAILS_REQUEST";
export const TENANT_UPDATE_COMPANY_DETAILS_SUCCESS =
  "TENANT_UPDATE_COMPANY_DETAILS_SUCCESS";
export const TENANT_UPDATE_COMPANY_DETAILS_FAIL =
  "TENANT_UPDATE_COMPANY_DETAILS_FAIL";
export const TENANT_UPDATE_COMPANY_DETAILS_RESET =
  "TENANT_UPDATE_COMPANY_DETAILS_RESET";

export const TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST =
  "TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST";
export const TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS =
  "TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS";
export const TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL =
  "TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL";
export const TENANT_UPDATE_SUBSCRIPTION_STATUS_RESET =
  "TENANT_UPDATE_SUBSCRIPTION_STATUS_RESET";

export const TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST =
  "TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST";
export const TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS =
  "TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS";
export const TENANT_GET_SUBSCRIPTION_LIMITS_FAIL =
  "TENANT_GET_SUBSCRIPTION_LIMITS_FAIL";
export const TENANT_GET_SUBSCRIPTION_LIMITS_RESET =
  "TENANT_GET_SUBSCRIPTION_LIMITS_RESET";

export const TENANT_GET_STRIPE_INVOICES_REQUEST =
  "TENANT_GET_STRIPE_INVOICES_REQUEST";
export const TENANT_GET_STRIPE_INVOICES_SUCCESS =
  "TENANT_GET_STRIPE_INVOICES_SUCCESS";
export const TENANT_GET_STRIPE_INVOICES_FAIL =
  "TENANT_GET_STRIPE_INVOICES_FAIL";
export const TENANT_GET_STRIPE_INVOICES_RESET =
  "TENANT_GET_STRIPE_INVOICES_RESET";

export const TENANT_GET_PUBLIC_DETAILS_REQUEST =
  "TENANT_GET_PUBLIC_DETAILS_REQUEST";
export const TENANT_GET_PUBLIC_DETAILS_SUCCESS =
  "TENANT_GET_PUBLIC_DETAILS_SUCCESS";
export const TENANT_GET_PUBLIC_DETAILS_FAIL = "TENANT_GET_PUBLIC_DETAILS_FAIL";
export const TENANT_GET_PUBLIC_DETAILS_RESET =
  "TENANT_GET_PUBLIC_DETAILS_RESET";

export const TENANT_INVITE_USER_REQUEST = "TENANT_INVITE_USER_REQUEST";
export const TENANT_INVITE_USER_SUCCESS = "TENANT_INVITE_USER_SUCCESS";
export const TENANT_INVITE_USER_FAIL = "TENANT_INVITE_USER_FAIL";
export const TENANT_INVITE_USER_RESET = "TENANT_INVITE_USER_RESET";

export const TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST =
  "TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST";
export const TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS =
  "TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS";
export const TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL =
  "TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL";
export const TENANT_UPDATE_DEFAULT_COORDINATOR_RESET =
  "TENANT_UPDATE_DEFAULT_COORDINATOR_RESET";

export const TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST =
  "TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST";
export const TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS =
  "TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS";
export const TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL =
  "TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL";
export const TENANT_UPDATE_TENANT_USER_PERMISSIONS_RESET =
  "TENANT_UPDATE_TENANT_USER_PERMISSIONS_RESET";

export const TENANT_DELETE_ACCOUNT_REQUEST = "TENANT_DELETE_ACCOUNT_REQUEST";
export const TENANT_DELETE_ACCOUNT_SUCCESS = "TENANT_DELETE_ACCOUNT_SUCCESS";
export const TENANT_DELETE_ACCOUNT_FAIL = "TENANT_DELETE_ACCOUNT_FAIL";
export const TENANT_DELETE_ACCOUNT_RESET = "TENANT_DELETE_ACCOUNT_RESET";
